var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"dense":"","hide-details":"","placeholder":_vm.placeholder,"readonly":!_vm.editable,"solo":!_vm.editable,"flat":!_vm.editable},on:{"change":function($event){return _vm.$emit('change', _vm.text)}},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})
}
var staticRenderFns = []

export { render, staticRenderFns }